import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimWorkOrderPriceMtrDistributionInput } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { bimWorkOrderPriceMTRDistributionTotalGql } from '../../bimWorkOrderQueries';

const requestId = 'bimWorkOrderPriceMTRDistributionTotal';

export const useBimWorkOrderPriceMTRDistributionTotal = (workOrderPriceId: number) => {
    const dispatch = useDispatch();
    const [bimWorkOrderPriceMTRDistributionTotalReset] = useResetStoreData({ requestId });

    const [
        bimWorkOrderPriceMTRDistributionTotalData,
        bimWorkOrderPriceMTRDistributionTotalStatus,
        bimWorkOrderPriceMTRDistributionTotalError,
        bimWorkOrderPriceMTRDistributionTotalRequest,
    ] = useRequest({
        requestId,
        query: bimWorkOrderPriceMTRDistributionTotalGql,
        withEffect: false,
    });

    const bimWorkOrderPriceMTRDistributionTotalMakeRequest = useCallback(
        (input: BimWorkOrderPriceMtrDistributionInput) => {
            bimWorkOrderPriceMTRDistributionTotalReset(undefined);
            dispatch(bimWorkOrderPriceMTRDistributionTotalRequest({ workOrderPriceId, input }));
        },
        [
            bimWorkOrderPriceMTRDistributionTotalRequest,
            bimWorkOrderPriceMTRDistributionTotalReset,
            dispatch,
            workOrderPriceId,
        ],
    );

    useEffect(() => {
        bimWorkOrderPriceMTRDistributionTotalReset(undefined);
    }, [bimWorkOrderPriceMTRDistributionTotalReset]);

    return {
        bimWorkOrderPriceMTRDistributionTotalReset,
        bimWorkOrderPriceMTRDistributionTotalData,
        bimWorkOrderPriceMTRDistributionTotalStatus,
        bimWorkOrderPriceMTRDistributionTotalError,
        bimWorkOrderPriceMTRDistributionTotalMakeRequest,
    };
};
